'use client';

import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../../services/ApiService';
import Poll from '../../components/Poll';
import FallBackImage from '../../components/FallBackImage';
import BreadCrumbs from '../../components/BreadCrumbs';
import PollsWrapper from './PollsWrapper';
import { twMerge } from 'tailwind-merge';

import { notFound } from 'next/navigation';
import {v7 as uuidv7} from 'uuid';
import Loader from '../../components/svg/Loader';
import SocialsShare from './SocialsShare';
import SocialsShareMobile from './SocialsShareMobile';

export default function PollWrapper({slug}:{slug: string}) {
  const {
    data,
    isLoading,
    isPending,
    isError,
    error
  } = useQuery({
    retry: 0,
    retryOnMount: false,
    staleTime: 0,
    gcTime: 0,
    queryKey: ['polls-collection', slug],
    queryFn: () => {
      let deviceId = localStorage.getItem('deviceId') as string;
      if (!deviceId) {
        deviceId = uuidv7();
        localStorage.setItem('deviceId', deviceId);
      }
      return apiService.getPollCollection(slug, deviceId)
    },
  });

  if (isError) {
    console.error(error.message || error);
    notFound();
  }

  if (isLoading || isPending) return <Loader className='w-fit mx-auto my-[24px]'/>;

  if (!data) return null;
  return (
        <div className='flex flex-col desktop:px-0 gap-[24px] desktop:max-w-[1296px]'>
      <FallBackImage src={data.image} thumbnail={data.image} alt={data.imageAlt || ''}  className={twMerge('w-full aspect-[1296/330] object-cover desktop:rounded-[12px]')} />
      <div className='flex flex-col gap-[24px] px-[24px] desktop:px-0 pb-[24px]'>
      <div className='flex items-start justify-between w-full gap-[24px]'>

      <BreadCrumbs className='overflow-x-hidden max-w-[80%] tablet:max-w-[unset]' items={[{title: 'الرئيسية', href: '/'}, {title: 'استطلاعات', href: '/voting'}, {title: data.titleAr, className: 'truncate line-clamp-1 max-w-full'}]}/>
                      <SocialsShare slug={data.slug} className='gap-[16px] hidden tablet:flex'/>
                    <SocialsShareMobile slug={data.slug} />
      </div>
      <PollsWrapper data={data} collectionSlug={slug}/>
      </div>
    </div>
  )
}